import {atom} from 'jotai';
import {atomWithStorage} from 'jotai/utils';
import {AnalysisItem, KodataCategoryGroup} from '@/map/@types';

export const anaysisListAtom = atom<AnalysisItem[]>([]);

export const analysisDrawItemAtom = atom<AnalysisItem | null>(null);

export const hallSalesCategoriesAtom = atomWithStorage<KodataCategoryGroup[]>(
  'myfc/hallsales/cats',
  []
);

export const activeAnalysisPanelAtom = atom<string | null>(null);

export const openCompareAreaAtom = atom<boolean>(false);

export const compareAreaItemsAtom = atom<string[]>([]);
